module.exports = __webpack_public_path__ + "static/media/Centreimage.79625dc1.png";